import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { C, field, btnPrimary, softShadow } from "../lib/theme";
import { toast } from "sonner";
import { Store } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornato!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10" style={softShadow} data-testid="login-card">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: C.CORAL }}>
            <Store className="w-6 h-6 text-white" />
          </span>
          <span className="font-display text-2xl font-extrabold" style={{ color: C.INK }}>Area ristoratori</span>
        </div>
        <p className="text-sm mb-8" style={{ color: C.MUTED }}>Accedi per gestire richieste e caparre.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} placeholder="tu@email.com" />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} placeholder="••••••••" />
          </div>
          <button data-testid="login-submit" disabled={loading} className={`${btnPrimary} w-full`}>
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
        <div className="mt-4 text-center">
          <Link to="/password-dimenticata" data-testid="forgot-password-link" className="text-sm font-semibold hover:underline" style={{ color: C.MUTED }}>Password dimenticata?</Link>
        </div>
        <p className="text-sm mt-6 text-center" style={{ color: C.MUTED }}>
          Non hai un account?{" "}
          <Link to="/registra" className="font-bold hover:underline" style={{ color: C.CORAL }}>Registra il tuo ristorante</Link>
        </p>
      </div>
    </div>
  );
}
